'use client';

import { Button, Stack, Typography } from '@mui/material';
import Image from 'next/image';

import ErrorImage from '../../public/statics/images/illustrations/error.png';

interface ErrorPageProps {
  errorMessage: string;
  title: string;
  showBackButton?: boolean;
}

export function ErrorPage(props: ErrorPageProps) {
  const { errorMessage, title, showBackButton = true } = props;

  return (
    <Stack
      flexGrow={1}
      alignItems='center'
      justifyContent='center'
      gap='24px'
      className='mt-[-40px]'
    >
      <Image
        alt='error'
        src={ErrorImage}
        width={546}
        height={533}
        loading='eager'
      />
      <Typography variant='h3'>{title}</Typography>
      <Typography variant='body1'>{errorMessage}</Typography>
      {showBackButton && (
        <Button onClick={() => history.back()} variant='outlined'>
          Back
        </Button>
      )}
    </Stack>
  );
}
